export const getDate = (date?: string) =>
  new Date(date?.replace(/-/g, '/') || '').getTime();
